import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import ctrlApi from "../lib/controlApi";

const Ctx = createContext(null);

export function ControlAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon
  const [role, setRole] = useState(null);
  const [perms, setPerms] = useState([]);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await ctrlApi.get("/auth/me");
      setUser(data.user); setRole(data.platform_role); setPerms(data.permissions || []);
    } catch {
      setUser(null); setRole(null); setPerms([]);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = useCallback(async (email, password) => {
    await ctrlApi.post("/auth/login", { email, password });
    await loadMe();
  }, [loadMe]);

  const logout = useCallback(async () => {
    try { await ctrlApi.post("/auth/logout"); } catch { /* ignore */ }
    setUser(null); setRole(null); setPerms([]);
  }, []);

  const stepUp = useCallback(async (password) => {
    const { data } = await ctrlApi.post("/auth/step-up", { password });
    return { "X-Control-StepUp": data.token };
  }, []);

  const can = useCallback((p) => perms.includes(p), [perms]);

  return <Ctx.Provider value={{ user, role, perms, login, logout, stepUp, can, loadMe }}>{children}</Ctx.Provider>;
}

export function useControlAuth() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useControlAuth must be inside ControlAuthProvider");
  return c;
}
